<template>
  <div
    class="grey darken-3 waggon-info-header-add"
    :style="`width: ${width};`"
    >
    <v-icon
      class="ml-1 mr-1"
      color="white"
      >
      add
    </v-icon>
  </div>
</template>
<script>
  export default {
    props: ['width'],
    computed: {
    }
  }
</script>
<style>
  .waggon-info-header-add {
    display: flex;
    height: 35px;
    border-radius: 3px 3px 0px 0px;
    line-height: 35px;
    user-select: none;
    cursor: pointer;
    color: white;
  }
</style>
